import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";
import { Helmet } from "react-helmet";
import Loadingimg from '../../components_root/loadingimg.jsx';
import Loading_items from "../../components_root/loading_items.jsx";
import logo_default from "../../assets/logo_default.jpg";
import Loading from "../../components_root/loading.jsx";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdArrowBackIos, MdClose } from "react-icons/md";
export const seoFallback = {
  title: "aooz | Amazing Products & Tools",
  description: "Check out products and services on aooz.",
  keywords: "aooz products, services, tools",
  url: "https://aooz.in",
  image: "https://aooz.in/assets/logo.png",
};

export default function Upload_file() {
  const location = useLocation();
  const navigate = useNavigate();
  const { Toastshow } = Toast();
   const servicetablename = "accountingfinancedb";
  const [voucherid, setVoucherid] = useState();
  const [voucher, setVoucher] = useState("");
  const [IsLoading2, setIsLoading2] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [brandnamedata, setBrandnameData] = useState([]);
  const [titlemete, setTitlemete] = useState("");
  const [keywordsmete, setKeywordsmete] = useState("");
  const [products_new_data, setProducts_new_data] = useState([]);
  const [vouchersdata, setVouchersdata] = useState([]);
  const [companydata, setCompanydata] = useState([]);
  const [slug, setSlug] = useState("");
  const select_company_uid = Cookies.get("select_company_uid");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const s = params.get("slug");
    if (s && s !== "null") setSlug(s);
  }, [location.search]);

  const fetchvouchers = async () => {
    if (!slug || !select_company_uid) return;

    const q = query(
      collection(db, servicetablename, select_company_uid, "vouchers"),
      where("slug", "==", slug)
    );
    const snap = await getDocs(q);

    if (snap.empty) {
      navigate(-1);
    }

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      const docs = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setVouchersdata(docs);

      const v = docs[0] || {};
      setVoucherid(v.voucherid || "");
      setVoucher(v.voucher || "");

    });

    return () => unsubscribe();
  };

  useEffect(() => {
    fetchvouchers();
  }, [slug]);

  const meta = {
    title: titlemete || seoFallback.title,
    description: seoFallback.description,
    keywords: keywordsmete || seoFallback.keywords,
    image: seoFallback.image,
    url: `https://aooz.in`,
  };


  return (
    <div  >

      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:url" content={meta.url} />
      </Helmet>
      <div className="b-bottom">
        <table>
          <tbody>
            <tr>
              <td>
                <div
                  onClick={() => navigate("/?page=vouchers")}
                  className="button-ui0 text-h2 bold p-2 cursor fcap"
                >
                  <MdArrowBackIos className="icon" /> {vouchersdata[0]?.voucher}
                </div>
              </td>
              <td width={30}>
                <div
                  onClick={() => navigate("/?page=vouchers")}
                  className="button-ui0 p-2 cursor"
                >
                  <MdClose className="icon" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}
